import * as React from "react";

import { GetPaymentMethodsResponse } from "@payment-client/interfaces/PaymentApi";

type SplitPayData = NonNullable<GetPaymentMethodsResponse["splitpayList"]>[number];

export interface SplitPayListContextValue {
    splitPayList: SplitPayData[];
}

export const SplitPayListContext = React.createContext<SplitPayListContextValue>({
    splitPayList: [],
});

if (__DEV__) {
    SplitPayListContext.displayName = "SplitPayListContext";
}
